function mobileMenu(burger, menu, header) {
  document.getElementById(burger).addEventListener("click", () => {
    if (header !== undefined) {
      const h = document.getElementById(header).offsetHeight;
      document.querySelector(`.${menu}`).style.top = `${h}px`;
    }

    document.getElementById(burger).classList.toggle("is-active");
    document.querySelector(`.${menu}`).classList.toggle("is-active");
    document.body.classList.toggle("noscroll");
    document.getElementById(burger).setAttribute("aria-expanded", document.getElementById(burger).getAttribute("aria-expanded") === "true" ? "false" : "true");
  });
}

// HTML to be inserted
//  <button id="hamburger" class="" aria-label="Main menu" aria-expanded="false">
//    <span class="line"></span>
//  </button>;

function faq() {
  const template = document.createElement('template')
  template.innerHTML = `
    <div class="faq content">
      <div class="faq__title" onClick="this.parentNode.classList.toggle('active'); this.nextElementSibling.classList.toggle('visually-hidden');">
        <p class="placeholder"><slot name="title" /></p>
        <span class="status"></span>
      </div>
      <div class="faq__content visually-hidden"><slot name="body" /></div>
    </div>
  `;

  class faqBlock extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({mode: 'open'});
      this.shadowRoot.appendChild(template.content.cloneNode(true));
    }
  }
  window.customElements.define('single-faq', faqBlock);
}

export { mobileMenu, faq };
